export const MAX_WIDTH = 1200;
export const JPEG_QUALITY = 0.65;

export function calculateDimensions(
  origWidth: number,
  origHeight: number,
  maxWidth: number
): { width: number; height: number } {
  if (origWidth <= maxWidth) {
    return { width: origWidth, height: origHeight };
  }
  const ratio = maxWidth / origWidth;
  return { width: maxWidth, height: Math.round(origHeight * ratio) };
}

function loadImage(dataUrl: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () =>
      reject(new Error('Failed to load image for compression'));
    img.src = dataUrl;
  });
}

export async function compressImage(dataUrl: string): Promise<string> {
  const img = await loadImage(dataUrl);
  const { width, height } = calculateDimensions(
    img.naturalWidth || img.width,
    img.naturalHeight || img.height,
    MAX_WIDTH
  );

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext('2d');
  if (!context) {
    throw new Error('Cannot compress image: 2D canvas context unavailable');
  }
  context.drawImage(img, 0, 0, width, height);

  return canvas.toDataURL('image/jpeg', JPEG_QUALITY);
}
